module.exports = __webpack_public_path__ + "img/top-image-960x541.2bf1c2eb.jpg";